<template lang="pug">
  img.transition-opacity.duration-300.w-full(ref="img", :class="[{'opacity-0': !loaded, 'absolute top-0 left-0 h-full': bg && thumb}, fit]", :src='thumb', :alt="image.alt || alt", @load="loaded = true")
</template>

<script>
export default {
  name: 'RespImgShopify',
  props: {
    image: { type: Object, default: undefined },
    alt: { type: String, default: 'Blue Mountain School' },
    bg: { type: Boolean, default: false },
    fit: { type: String, default: 'object-cover object-center' }
    // lazy: { type: Boolean, default: true },
    // anim: { type: Boolean, default: true } // animate lazyload
  },
  data () {
    return {
      thumb: '',
      loaded: false
    }
  },
  computed: {
    src () {
      return this.image && this.image.originalSrc
    }
  },
  methods: {
    getSizeByFit () {
      /*
       * optimized image size, based on image asset aspect-ratio (AR) against <img>
      */
      let size = []
      // non-bg? use width
      if (!this.bg) {
        size = [this.$el.offsetWidth]
      // bg? figure out which dimension is filling the parent
      } else {
        const parent = this.$el.parentElement
        const parentAR = parent.offsetWidth / parent.offsetHeight // 2x3 = 0.66
        // if portrait frame, size by height since can't know shopify img dimensions :(
        const resizeByHeight = parentAR < 1
        size = resizeByHeight ? [null, parent.offsetHeight] : [parent.offsetWidth]
      }
      return size
    }
  },
  mounted () {
    // optimized image size, based on el width (must be rendered)
    this.thumb = resizeShopifyImg(this.src, this.getSizeByFit())
  }
}

// find image size
export function optimImgSize (length) {
  const sizes = [480, 960, 1280, 1600, 2048, 3072, 4096]
  const dpx = window.devicePixelRatio || 1
  length = dpx > 1 ? length * dpx * 0.75 // less density optically ok ? (target 80%)
    : length
  // find optimal
  return sizes.find(sz => length <= sz) || sizes[sizes.length - 1]
}

// Shopify resizer
export function resizeShopifyImg (url, size = []) {
  const w = size[0] ? optimImgSize(size[0]) : ''
  const h = size[1] ? optimImgSize(size[1]) : ''
  const dot = url.lastIndexOf('.') // hopefully .jpg or .png etc
  return `${url.slice(0, dot)}_${w}x${h}${url.slice(dot)}`
}
</script>

<style>
/* lazysizes - fade in on loaded*/
:not(.no-lazyload-anim) {
  &.lazyload,
  &.lazyloading {
    opacity: 0;
  }
  &.lazyloaded {
    opacity: 1;
    transition: opacity 300ms;
  }
}
</style>

<!--
lazysizes loaded image, using "modern srcset" approach
* https://github.com/aFarkas/lazysizes#modern-transparent-srcset-pattern
-->
